import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { getFindPayHeader, getSmWownet, getSmWownetPg, getWowWord, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { getPdtImages, getPdtInfo, PdtDetailState } from '@app/selectors/shoppingmall/pdt-detail.selector';
import { CartState } from '@app/selectors/shoppingmall/cart.selector';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { ValidationUtil } from '@app/common/util/validation.util';
import { ImageKindConstant } from '@app/common/constant/image-kind.constant';
import { addToCart, setIsBuyNow, setShowAlert } from '@app/actions/shoppingmall/cart.action';
import { SmPayHeaderModel } from '@app/models/system/sm-pay-header.model';
import { WownetWordModel } from '@app/models/system/wownet-word.model';
import { CartUtil } from '@app/common/util/cart.util';
import { loadPdtImagesSuccess, setProductNameMainHeading } from '@app/actions/shoppingmall/pdt-detail.action';
import { getWAlertStatus, WAlertState } from '@app/selectors/w-alert.selector';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { setPdtCate } from '@app/actions/shoppingmall/product.action';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@enviroments/environment';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { CustomerPrice } from '@app/pipes/customer-price.pipe';
import { SwiperService } from '@app/services/common/swiper.service';

declare const getYnPayHeader: any;
declare const productDetailSwiper: any;
declare const shareOnListenner: any;
declare const kakaoShareMessage : any;

@Component({
  selector: 'product-meta',
  templateUrl: './product-meta.component.html',
  styleUrls: ['./product-meta.component.css'],
  providers: [CustomerPrice]
})
export class ProductMetaComponent implements OnInit, OnDestroy {

  smWownet$ = new Observable<SmWownetModel>();
  urlWownet: string = "";

  pdtInfo$ = new Observable<PdtDetailModel>();
  pdtInfo: PdtDetailModel = {} as PdtDetailModel;

  pdtImages$ = new Observable<PdtDetailModel[]>();
  pdtImages: PdtDetailModel[] = [];
  activeImage: PdtDetailModel = {} as PdtDetailModel;

  smPayHeader$ = new Observable<SmPayHeaderModel>();

  smWowWord$ = new Observable<WownetWordModel>();
  smWowWord: any = {} as WownetWordModel ;

  smWownetPg$ = new Observable<SmWownetPgModel>();
  smWownetPg: any = {} as SmWownetPgModel;

  @Input() 
  total: number = 0;

  @Input() 
  quantity: number = 1;

  pvw: String = "AV";
  isLogined: boolean = false;
  isPv1: boolean = false;
  isPv2: boolean = false;
  isPv3: boolean = false;
  isPoint: boolean = false;
  isRetailAmt: boolean = false;
  isAmt: boolean = false;
  isOrd: boolean = false;
  isDisableBuying: boolean = false;
  wAlertStatus$ = new Observable<WAlertStatus>();
  subPdtImages$ = {} as Subscription;
  actionConfirmLogined: string = "action_confirm_logined";

  havePdtInfo: boolean = false;

  userKind: string = '';

  chkMemEdu: string = "N";

  detailswiperConfig = {
    spaceBetween: 20,
		slidesPerView: 6,
		freeMode: true,
		watchSlidesProgress: true,
  };

  @Input() 
  wishYn: string = '';

  @Output() 
  changePlus = new EventEmitter<string>();

  @Output() 
  changeMinus = new EventEmitter<string>();

  @Output()
  changeWish = new EventEmitter<string>();


  constructor(
    private _router: Router,
    private _smWownetStore: Store<SmWownetState>,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _pdtDetailStore: Store<PdtDetailState>,
    private _cartStore: Store<CartState>,
    private _smWownetStateStore: Store<SmWownetState>,
    private _wAlertStore: Store<WAlertState>,
    private _productStore: Store<ProductState>,
    private _translate:TranslateService,
    private _http: HttpClient,
    private _custPrice: CustomerPrice,
    private swipperService:SwiperService
  ) { 
    this.smWownet$ = this._smWownetStore.select(getSmWownet);
    this.pdtInfo$ = this._pdtDetailStore.select(getPdtInfo);
    this.pdtImages$ = this._pdtDetailStore.select(getPdtImages);
    this.smPayHeader$ = this._smWownetStateStore.select(getFindPayHeader);
    this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
    this.smWowWord$ = this._smWownetStateStore.select(getWowWord);
    this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
  }
  ngOnDestroy(): void {
    let hasValue = this.subPdtImages$.closed != undefined
    if(this.subPdtImages$ && hasValue){
      this.subPdtImages$.unsubscribe()
    }
    this._pdtDetailStore.dispatch(loadPdtImagesSuccess({ items: [] }))
  }

  ngOnInit(): void {
    let member = AuthUtil.getLoginedInfo();
    this.userKind = ConvertUtil.convertToSring(member?.userKind).substr(3, 3);

    let ele = document.getElementById('sort-category') as HTMLElement;
    ele.style.display = 'none';
    this.isLogined = AuthUtil.isLogined();

    this.smWownetPg$.subscribe(res => this.isPoint = res.mpoint === "Y");
    
    this.smPayHeader$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.isPv1 = getYnPayHeader(res, "pv1");
        this.isPv2 = getYnPayHeader(res, "pv2");
        this.isPv3 = getYnPayHeader(res, "pv3");
      }
    });

    this.smWownet$.subscribe(res => {
      this.urlWownet = ConvertUtil.convertToSring(res.urlWownet);
      if (this.isLogined) {
        this.isOrd = true;
      } else {
        this.isOrd = res.lOrdYn === "Y";
      }
      this.isAmt = res.lShowAmtYn === "Y";
      this.isRetailAmt = res.lShowRetailYn === "Y";
     });

    this.smWowWord$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.smWowWord = res;
        setTimeout(() => {
          this.pvw = (this.isPv1?res.oPv1:( this.isPv2?res.oPv2:(this.isPv3?res.oPv3:"AV")))
        }, 100);
      }
    });

    this.pdtInfo$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res.cateCd)){
        this._http.get(`${environment.apiUrl}/product/chkMemEdu?comId=${environment.comId}&userid=${AuthUtil.getLoginedInfo()?.userid}`, { responseType: 'text' }).subscribe((response: string) => {
          this.chkMemEdu = response;
         
        }, (error) => {
          console.error(error);
        })

        
        setTimeout(() => {
          if(res.cateCd == '0115' && this.chkMemEdu == 'N'){
            this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: '권한이 없습니다.' } }));
            this._router.navigate([MyProgramConstant.urlShopping + `/category/all`]);;
          }
        }, 2500);
        
      }
      if (!this.havePdtInfo) {
        //this._productStore.dispatch(setPdtCate({ cate: ConvertUtil.convertToSring(res.cateCd) }));
        this.pdtInfo = res;
        this._pdtDetailStore
        //this.total = +(this._custPrice.transform(res.retailAmt, res.amt));
        if( res && res.saleMaxQty == "0" && res.saleMinQty == "0"){
          this.isDisableBuying = true;
        }
      }
      if (ValidationUtil.isNotNullAndNotEmpty(this.pdtInfo) && ValidationUtil.isNotNullAndNotEmpty(this.pdtInfo.pdtName)) {
        let pdtName = ConvertUtil.convertToSring(this.pdtInfo.pdtName);
        this._pdtDetailStore.dispatch(setProductNameMainHeading({ heading: pdtName }));
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
      if (ValidationUtil.isNotNullAndNotEmpty(res.pdtCd)) {
        this.havePdtInfo = true;
      }

    });

    this.subPdtImages$ = this.pdtImages$.subscribe(res => {
      this.pdtImages = res.filter(x => x.imageKind === ImageKindConstant.large && ValidationUtil.isNotNullAndNotEmpty(x.fileName));
      if (ValidationUtil.isNotNullAndNotEmpty(this.pdtImages)) {
        setTimeout(() => {
          productDetailSwiper();
        }, 1000);
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this._cartStore.dispatch(setShowAlert({ show: true }));
    this.wAlertStatus$.subscribe(res => this.handleActionConfirm(res));
  }

  handleOnClickPlus(): void {
    this.changePlus.emit('');
  }

  handleOnClickMinus(): void {
    this.changeMinus.emit('');
  }

  handleOnClickAddToCart(): void {
    if (this.isLogined) {
      if (Number(this.pdtInfo.amt) <= 0) {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: this._translate.instant("homepage.product.msg.005") } }));
        return;
      }
      this._cartStore.dispatch(setIsBuyNow({ isBuyNow: false }));
      this.addToCart();
    } else {
      this.alertNotLogined();
    }
  }

  handleOnClickBuyNow(): void {
    if (this.isLogined) {
      if (Number(this.pdtInfo.amt) <= 0) {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message:this._translate.instant("homepage.product.msg.005")  } }));
        return;
      }
      this._cartStore.dispatch(setIsBuyNow({ isBuyNow: true }));
      this.addToCart();
    } else {
      this.alertNotLogined();
    }
  }

  handleOnClickFeaturedWrapperImage(item: PdtDetailModel): void {
    this.activeImage = item;
  }

  addToCart(): void {
    let pdtCd = this.pdtInfo.pdtCd;
    if (ValidationUtil.isNotNullAndNotEmpty(pdtCd)) {
      let params = CartUtil.getParamsAddToCart(ConvertUtil.convertToSring(pdtCd), this.quantity);
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
      this._cartStore.dispatch(addToCart({ params: params }));
    }
  }

  handleActionConfirm(status: WAlertStatus): void {
    if (status.action === this.actionConfirmLogined && status.isConfirm) {
      this._wAlertStore.dispatch(clearWAlert());
      this._router.navigate(["/login"]);
    }
  }


  alertNotLogined(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: this._translate.instant("homepage.login.msg.001") , action: this.actionConfirmLogined } }));
  }

  isMatchDate(sdate :String , edate:String ) :boolean{
		if(ValidationUtil.isNotNullAndNotEmpty(sdate) || ValidationUtil.isNotNullAndNotEmpty(edate)){
		  let check = true;
		  const currentDate = Number(this.getCurrentDate())
		  if(Number(sdate) >= currentDate){
			check = false
		  }
		  if(ValidationUtil.isNotNullAndNotEmpty(edate) && Number(edate) <= currentDate ){
			check = false
		  }
		  return check;
		}else{
		  return false;
		}
  
	}

  getCurrentDate(): string {
		const currentDate = new Date();
  
		const year = currentDate.getFullYear();
		const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
		const day = currentDate.getDate().toString().padStart(2, '0');
  
		return `${year}${month}${day}`;
	}

  onClickWishList(event: any): void {
		this.changeWish.emit(this.wishYn);
		event.stopPropagation();
	}
}
